import { addDays } from "date-fns";

import { IFlightSearch } from "@/core/interfaces/IFlightSearch.interface";
import { ROUTE_TYPE } from "@/core/enums/ROUTE_TYPE";
import { CABIN_CLASS } from "@/core/enums/CABIN_CLASS";
import { AMOUNT_TYPE, FARE_TYPE } from "@/core/enums/FARE_CALCULATOR";

const flightState: IFlightSearch = {
  sabreAirlines: [],
  galileoAirline: [],
  flightProviders: [],

  isPolling: true,
  isFlightFetching: false,
  isAirportFetching: false,
  isLoading: false,
  currentLegIndex: 0,
  lastLegIndex: 0,
  flightsResponse: {
    is_international: false,
    route_type: ROUTE_TYPE.ONEWAY,
    journey_legs: [],
    poll_id: null,
    keep_polling: true,
    full_result: false,
  },
  flights: [],
  airports: [],
  selectedFlightFilters: {
    airlines: [],
    stops: [],
    rtStops: [],
    priceRange: [],
    departureTime: [],
  },
  amountType: AMOUNT_TYPE.FIXED,
  fareType: FARE_TYPE.GROSS,
  fareCalculatorAmount: null,
  selectedFlightLegs: [],
  selectedFares: [],
  selectedFilteredLegsByFareIds: [],

  /********* Flight Search Query State *********/
  origin: null,
  destination: null,
  departure_date: null,
  return_date: null,
  route_type: ROUTE_TYPE.ONEWAY,
  hasInitializedFromUrl: false,
  adult_count: 1,
  child_count: 0,
  infant_count: 0,
  selectedPassengerIds: [],
  selectedPassengerProfiles: [],
  isFetchingSelectedPassengerProfiles: false,
  guestTravelerCounts: {
    adult_count: 0,
    child_count: 0,
    infant_count: 0,
  },
  cabin_class: CABIN_CLASS.ECONOMY,
  originAirports: [],
  destinationAirports: [],
  loadingOriginAirports: false,
  loadingDestinationAirports: false,
  loadingFinancialProfiles: false,
  multiCityAirports: [
    {
      origin: [],
      destination: [],
    },
    {
      origin: [],
      destination: [],
    },
  ],
  currentMultiCityAirportInputTypeLoading: null,
  currentMultiCityAirportInputIndexLoading: null,
  multiCityLegs: [
    {
      origin: null,
      destination: null,
      departure_date: new Date(),
    },
    {
      origin: null,
      destination: null,
      departure_date: addDays(new Date(), 1),
    },
  ],
  filters: {
    airlines: [],
    stops: [],
    rtStops: [],
    priceRange: [],
    departureTime: [],
  },
  searchFinancialProfiles: null,
  enabledAirlines: null,
  selectedAirlines: null,
  pricing: null,
  currencyCodes: null,
  selectedCurrencyCode: null,
  selectedFinancialProfile: "",
};

export default flightState;
